import React from 'react'
import Skeleton from '@material-ui/lab/Skeleton'
import Typography from '@material-ui/core/Typography'
import useStyles from './stylesSkeleton'

const SkeletonItem = () => {
  const classes = useStyles()
  return (
    <div className={classes.root}>
      <div className={classes.itemCheckboxWrapper}>
        <Skeleton
          className={classes.itemCheckbox}
          variant="circle"
          width={16}
          height={16}
        />
      </div>
      <Typography component="div" variant="body2" className={classes.itemText}>
        <Skeleton />
      </Typography>
      <div className={classes.itemActions}>
        <Skeleton
          className={classes.itemIcon}
          variant="circle"
          width={88}
          height={16}
        />
      </div>
    </div>
  )
}

export default SkeletonItem
